import React from "react";
import Grid from "@mui/material/Grid2";
import Button from "@mui/material/Button";
import RequiredOptionsModal from "./RequiredOptionsModal";
import Paper from "@mui/material/Paper";
import OptionsNotification from "./OptionsNotification";
import useDebugInformation from "../../../../../../../../hooks/useDebugInformation";
import { ui } from "../../../../../../../../interfaces/interfaces";
import NumberedHeader from "../../../../../../../Shared/NumberedHeader";
import { useAppSelector } from "@store/hooks";

const name = "RequiredOptions"

export const displayRequiredModal = () => (ui.RequiredModal = true);

type Props = {
    parent: string
}

const RequiredOptions: React.FC<Props> = ({ parent }) => {
    const requiredOptions = useAppSelector(({ temp }) => temp.RequiredOptions)
    const requiredModal = useAppSelector(({ ui }) => ui.RequiredModal)
    const requiredOptionsValid = useAppSelector(({ state }) => state.RequiredOptionsValid)
    const debugName = `${parent}▷[${name}]`

    useDebugInformation(debugName, { parent })
    return (
        (<Paper elevation={4} sx={(theme) => ({
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
            padding: theme.spacing(2),
            [theme.breakpoints.up(600 + Number(theme.spacing(3)) * 2)]: {
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(2),
                padding: theme.spacing(2),
            },
            '& input': { height: "1em" }
        })}>
            <Grid container spacing={1}>
                <NumberedHeader number="2" description="REQUIRED QUESTIONS" variant={requiredOptionsValid ? "green" : "red"} />
                {requiredOptions
                    && (
                        <Grid
                            display="inline-flex"
                            columnGap={2}
                            size={{
                                xs: 12,
                                sm: 12
                            }}>
                            <Button sx={{ lineHeight: 1.4 }} variant="contained" color="primary" onClick={displayRequiredModal}>Required questions</Button>
                            <OptionsNotification />
                        </Grid>
                    )}
                {requiredModal && <RequiredOptionsModal />}

            </Grid>
        </Paper>)
    );
}

export default React.memo(RequiredOptions)